import { ExternalLink, Zap } from 'lucide-react'
import { APP_BASE_URL } from '@/lib/constants'

export function UpgradePrompt() {
  return (
    <div className="mx-4 mt-4 rounded-lg border border-warning-DEFAULT/30 bg-warning-DEFAULT/5 p-4">
      <div className="flex items-start gap-3">
        <Zap size={16} className="text-warning-DEFAULT mt-0.5 shrink-0" />
        <div>
          <p className="text-sm font-medium text-secondary-800">Matter Planner Required</p>
          <p className="text-xs text-secondary-500 mt-0.5">
            This feature requires an active Matter Planner subscription.
          </p>
          <a
            href={`${APP_BASE_URL}/settings/billing`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            Upgrade now
            <ExternalLink size={11} />
          </a>
        </div>
      </div>
    </div>
  )
}
